// Shown when authenticated but the user's org groups are not allowed (backend 403).
export const AUTH_FORBIDDEN_MESSAGE = 'Sie sind nicht berechtigt, das Feature-Flag-Tool zu verwenden';
